import { IBreadcrumbMeta } from "cdp-fe-commons-layout";
import catalogoPIRoutes from "@/router/catalogoPIRoutes";
import procedimentoRoutes from "@/router/procedimentoRoutes";
import userRoutes from "@/router/userRoutes";

const Home = () => import('@/views/Home.vue');
const Login = () => import('@/components/login/Login.vue');

const homeRoutes = [
    {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: {
            requiresAuth: false,
            breadcrumb: { exclude: true } as IBreadcrumbMeta,
            layout: 'no-layout',
        }
    },
    {
        path: 'home',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true,
            breadcrumb: {
                title: "Home",
            } as IBreadcrumbMeta,
            layout: 'default-layout'
        },
    },
] as any[];

const defaultRoute = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/:catchAll(.*)',
        redirect: '/login'
    }
];

export default homeRoutes.concat(
    catalogoPIRoutes,
    procedimentoRoutes,
    userRoutes,
    defaultRoute
);
